import { useCallback, useState } from "react"

import { Col, Container, Row } from "react-bootstrap"
import { FaPaperPlane, FaUserMinus, FaUserPlus } from "react-icons/fa"

import NotificationContactEditModal from "./NotificationEditModal"
import NotificationGrid from "./NotificationGrid"
import { useNotificationContacts } from "../../../api/Randoms/Notification/useNotificationContacts"
import { useNotificationContactsActions } from "../../../api/Randoms/Notification/useNotificationContactsActions"
import ActionButtonWithIcon from "../../ActionButtonWithIcon"
import ConfirmationModal from "../../ConfirmationModal"

function NotificationDetails() {
  const { poolId, loadingContacts, deletingContacts, sendingNotifications, selectedContacts } =
    useNotificationContacts()
  const { deleteContacts, sendNotifications } = useNotificationContactsActions()

  const [showContactForm, setShowContactForm] = useState(false)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [showSendNotificationConfirmation, setSendNotificationConfirmation] = useState(false)

  const handleDeleteContacts = useCallback(() => {
    deleteContacts(poolId, selectedContacts)
    setShowDeleteConfirmation(false)
  }, [poolId, deleteContacts, selectedContacts])

  const handleSendNotifications = useCallback(() => {
    sendNotifications(poolId, selectedContacts)
    setSendNotificationConfirmation(false)
  }, [poolId, sendNotifications, selectedContacts])

  const isDeleting = () => {
    return Object.values(deletingContacts).some((value) => value === true)
  }

  const isSending = () => {
    return Object.values(sendingNotifications).some((value) => value === true)
  }

  const isNotificationPossible = () => {
    return selectedContacts.some((contact) => contact?.NotificationMethods?.length > 0)
  }

  return (
    <Container fluid className="grid-container pb-3">
      <Row>
        <Col>
          <h5>NOTIFICATION CONTACTS</h5>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <ActionButtonWithIcon
            icon={<FaUserPlus />}
            variant="secondary"
            disabled={loadingContacts}
            onClick={() => setShowContactForm(true)}
          >
            ADD CONTACT
          </ActionButtonWithIcon>
        </Col>
      </Row>
      <Row>
        <Col>
          <NotificationGrid />
        </Col>
      </Row>
      {showContactForm && <NotificationContactEditModal onHide={() => setShowContactForm(false)} />}
      <Row className="buttons-block pr-0">
        <Col className="d-flex justify-content-end align-items-center">
          <ActionButtonWithIcon
            icon={<FaUserMinus />}
            variant="secondary"
            disabled={loadingContacts || (selectedContacts?.length ?? 0) === 0}
            onClick={() => setShowDeleteConfirmation(true)}
            spin={isDeleting()}
            disableOnSpin
            className="mr-1"
          >
            DELETE CONTACTS
          </ActionButtonWithIcon>
          <ActionButtonWithIcon
            icon={<FaPaperPlane />}
            variant="primary"
            disabled={loadingContacts || !isNotificationPossible()}
            onClick={() => setSendNotificationConfirmation(true)}
            spin={isSending()}
            disableOnSpin
          >
            SEND NOTIFICATIONS
          </ActionButtonWithIcon>
        </Col>
      </Row>
      <ConfirmationModal
        show={showDeleteConfirmation}
        title="CONFIRM REMOVE CONTACTS"
        textTitle={`Are you sure you want to remove \n${selectedContacts?.length} contact(s)?`}
        onConfirm={handleDeleteContacts}
        onHide={() => setShowDeleteConfirmation(false)}
      />
      <ConfirmationModal
        show={showSendNotificationConfirmation}
        title="CONFIRM SENDING NOTIFICATIONS"
        textTitle={`Are you sure you want to send notifications \n${selectedContacts?.length} to contact(s)?`}
        onConfirm={handleSendNotifications}
        onHide={() => setSendNotificationConfirmation(false)}
      />
    </Container>
  )
}

export default NotificationDetails
